// Generated by ReScript, PLEASE EDIT WITH CARE

import * as View from "../../primitives/View.res.js";
import * as React from "react";
import * as ReactAria from "react-aria";
import * as ReactStately from "../../externals/ReactStately.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately$1 from "react-stately";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "backgroundColor-kWkggS": "backgroundColor-x12peec7",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    "paddingTop-kLKAdn": "paddingTop-x1iorvi4",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:16"
  },
  Tab_root: {
    "color-kMwMTN": "color-x1kqwvl4",
    "font-kVVagm": "font-xyeg6z0",
    "lineHeight-kLWn49": "lineHeight-x1d3mw78",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "cursor-kkrTdU": "cursor-x1ypdohk",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "padding-kmVPX3": "padding-x1ifpib",
    "position-kVAEAm": "position-x1n2onr6",
    ":hover_color-kDPRdz": "color-x1d1u344",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:22"
  },
  Tab_selected: {
    "color-kMwMTN": "color-xavitmu",
    "textShadow-kKMj4B": "textShadow-x1kay2tc",
    "cursor-kkrTdU": "cursor-xt0e3qv",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:37"
  },
  Tab_disabled: {
    "color-kMwMTN": "color-x1w2voyz",
    "borderBottomColor-kL6WhQ": "borderBottomColor-xhj81ty",
    "borderBottomStyle-kfdmCh": "borderBottomStyle-x1q0q8m5",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-xlxy82",
    "cursor-kkrTdU": "cursor-xt0e3qv",
    "paddingBottom-kGO01o": "paddingBottom-x1a8lsjc",
    ":hover_color-kDPRdz": "color-x1jq5bfx",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:42"
  },
  TabLabel_root: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    "gap-kOIVth": "gap-x167g77z",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:53"
  },
  TabLabel_statusLight: {
    "backgroundColor-kWkggS": "backgroundColor-xjc0qvw",
    "borderRadius-kaIpWk": "borderRadius-x16rqkct",
    "height-kZKoxP": "height-xols6we",
    "marginBottom-k1K539": "marginBottom-x1ty9z65",
    "width-kzqmXN": "width-x1v4s8kt",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:59"
  },
  TabSelectionIndicator_root: {
    "backgroundColor-kWkggS": "backgroundColor-xjc0qvw",
    "transition-kmkexE": "transition-x1ctskc",
    "willChange-k6sLGO": "willChange-xgmitkr",
    "bottom-krVfgx": "bottom-x1ey2m1c",
    "height-kZKoxP": "height-x36qwtl",
    "position-kVAEAm": "position-x10l6tqk",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/resources/navigation/CategoryTablist.res.js:66"
  }
};
let make = React.memo(props => {
  let match = {
    className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-x1q0g3np gap-x167g77z",
    "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:53"
  };
  let statusLightStyleProps = {
    className: "backgroundColor-xjc0qvw borderRadius-x16rqkct height-xols6we marginBottom-x1ty9z65 width-x1v4s8kt",
    "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:59"
  };
  return JsxRuntime.jsxs(View.make, {
    children: [props.label, props.statusLight ? JsxRuntime.jsx(View.make, {
      className: statusLightStyleProps.className,
      style: statusLightStyleProps.style
    }) : null],
    className: match.className,
    style: match.style
  });
});
let TabLabel = {
  make: make
};
function styleProps(width, left) {
  return Stylex.props(styles.TabSelectionIndicator_root, {
    transform: `translateX(` + String(left) + `px)`,
    width: String(width) + "px"
  });
}
let make$1 = React.memo(props => {
  let match = styleProps(props.width, props.left);
  return JsxRuntime.jsx(View.make, {
    className: match.className,
    style: match.style
  });
});
let TabSelectionIndicator = {
  styleProps: styleProps,
  make: make$1
};
function styleProps$1(selected, disabled) {
  return {
    0: {
      className: "color-x1kqwvl4 font-xyeg6z0 lineHeight-x1d3mw78 whiteSpace-xuxw1ft cursor-x1ypdohk alignItems-x6s0dn4 display-x78zum5 justifyContent-xl56j7k padding-x1ifpib position-x1n2onr6 color-x1d1u344",
      "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:22"
    },
    2: {
      className: "font-xyeg6z0 lineHeight-x1d3mw78 whiteSpace-xuxw1ft alignItems-x6s0dn4 display-x78zum5 justifyContent-xl56j7k padding-x1ifpib position-x1n2onr6 color-x1d1u344 color-xavitmu textShadow-x1kay2tc cursor-xt0e3qv",
      "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:22; wino-gc:src/resources/navigation/CategoryTablist.res.js:37"
    },
    1: {
      className: "font-xyeg6z0 lineHeight-x1d3mw78 whiteSpace-xuxw1ft alignItems-x6s0dn4 display-x78zum5 justifyContent-xl56j7k padding-x1ifpib position-x1n2onr6 color-x1w2voyz borderBottomColor-xhj81ty borderBottomStyle-x1q0q8m5 borderBottomWidth-xlxy82 cursor-xt0e3qv paddingBottom-x1a8lsjc color-x1jq5bfx",
      "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:22; wino-gc:src/resources/navigation/CategoryTablist.res.js:42"
    },
    3: {
      className: "font-xyeg6z0 lineHeight-x1d3mw78 whiteSpace-xuxw1ft alignItems-x6s0dn4 display-x78zum5 justifyContent-xl56j7k padding-x1ifpib position-x1n2onr6 textShadow-x1kay2tc color-x1w2voyz borderBottomColor-xhj81ty borderBottomStyle-x1q0q8m5 borderBottomWidth-xlxy82 cursor-xt0e3qv paddingBottom-x1a8lsjc color-x1jq5bfx",
      "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:22; wino-gc:src/resources/navigation/CategoryTablist.res.js:37; wino-gc:src/resources/navigation/CategoryTablist.res.js:42"
    }
  }[!!selected << 1 | !!disabled << 0];
}
let make$2 = React.memo(props => {
  let item = props.item;
  let ref = React.useRef(null);
  let match = ReactAria.useTab({
    key: item.key
  }, props.state, ref);
  let match$1 = styleProps$1(match.isSelected, match.isDisabled);
  let newrecord = {
    ...match.tabProps
  };
  return JsxRuntime.jsx(ReactAria.FocusScope, {
    children: JsxRuntime.jsx(View.make, (newrecord.style = match$1.style, newrecord.className = match$1.className, newrecord.ref = Primitive_option.some(ref), newrecord.children = item.rendered, newrecord)),
    restoreFocus: true,
    autoFocus: false
  });
});
let Tab = {
  styleProps: styleProps$1,
  make: make$2
};
function styleProps$2() {
  return {
    className: "backgroundColor-x12peec7 display-x78zum5 flexDirection-x1q0g3np paddingTop-x1iorvi4",
    "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:16"
  };
}
let make$3 = React.memo(props => {
  let onChange = props.onChange;
  let items = props.items;
  let match = React.useState(() => ({
    width: 0,
    left: 0
  }));
  let setTabIndicatorStyle = match[1];
  let tabIndicatorStyle = match[0];
  let nodeElements = items.map(item => JsxRuntime.jsx(ReactStately$1.Item, {
    children: JsxRuntime.jsx(make, {
      label: item.label,
      statusLight: Stdlib_Option.getOr(item.statusLight, false)
    }),
    textValue: item.label
  }, item.key));
  let disabledKeys = Stdlib_Array.filterMap(items, item => {
    if (item.disabled === true) {
      return item.key;
    }
  });
  let props_disabledKeys = disabledKeys;
  let props_selectedKey = Primitive_option.some(props.value);
  let props_onSelectionChange = key => {
    if (!(key == null)) {
      return onChange(key);
    }
  };
  let props$1 = {
    "aria-label": "category-tablist",
    children: nodeElements,
    disabledKeys: props_disabledKeys,
    selectedKey: props_selectedKey,
    onSelectionChange: props_onSelectionChange
  };
  let state = ReactStately$1.useTabListState(props$1);
  let ref = React.useRef(null);
  let match$1 = ReactAria.useTabList(props$1, state, ref);
  React.useEffect(() => {
    let selectedKeyInItems = items.some(item => item.key === Primitive_option.fromNullable(state.selectedKey));
    if (!selectedKeyInItems) {
      let defaultItem = items[0];
      if (defaultItem !== undefined) {
        state.setSelectedKey(defaultItem.key);
      }
    }
  }, [state.selectedKey]);
  React.useLayoutEffect(() => {
    let selectedTabElement = Stdlib_Option.flatMap(ReactDomElement.fromRef(ref), domElement => Primitive_option.fromNullable(domElement.querySelector(`[role="tab"][aria-selected="true"]`)));
    if (selectedTabElement !== undefined) {
      let selectedTabElement$1 = Primitive_option.valFromOption(selectedTabElement);
      let width = selectedTabElement$1.offsetWidth | 0;
      let left = selectedTabElement$1.offsetLeft | 0;
      setTabIndicatorStyle(param => ({
        width: width,
        left: left
      }));
    }
  }, [state.selectedKey]);
  let match$2 = {
    className: "backgroundColor-x12peec7 display-x78zum5 flexDirection-x1q0g3np paddingTop-x1iorvi4",
    "data-style-src": "wino-gc:src/resources/navigation/CategoryTablist.res.js:16"
  };
  let newrecord = {
    ...match$1.tabListProps
  };
  return JsxRuntime.jsxs(View.make, {
    children: [JsxRuntime.jsx(View.make, (newrecord.style = match$2.style, newrecord.className = match$2.className, newrecord.ref = Primitive_option.some(ref), newrecord.children = ReactStately.Collection.toArray(state.collection).map(item => JsxRuntime.jsx(make$2, {
      item: item,
      state: state
    }, item.key)), newrecord)), JsxRuntime.jsx(make$1, {
      width: tabIndicatorStyle.width,
      left: tabIndicatorStyle.left
    })],
    style: {
      position: "relative"
    }
  });
});
export { styles, TabLabel, TabSelectionIndicator, Tab, styleProps$2 as styleProps, make$3 as make };
/* styles Not a pure module */